/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import ProfilesList from "examples/Lists/ProfilesList";
import CardMedia from "@mui/material/CardMedia";
// Overview page components
import Header from "layouts/userProfile/components/Header";
import PlatformSettings from "layouts/userProfile/components/PlatformSettings";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getusersDetail } from "../../redux/slices/userDetailSlice";
import { useParams } from "react-router";
import { InfoRow } from "utils/InfoRow";
import { formatDate } from "utils/formatData";
import { baseUrl } from "services/axiosInstance";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageGrid from "examples/ImageGrid";

function UserProfile() {
  const { id } = useParams();
  const { userDetail: user } = useSelector((state) => state.userDetail);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getusersDetail({
        userId: id,
      })
    );
  }, []);

  const srcset = (image, size) => {
    return {
      src: `${baseUrl + image}?w=${size}&h=${size}&fit=crop&auto=format`,
      srcSet: `${baseUrl + image}?w=${size}&h=${size}&fit=crop&auto=format&dpr=2 2x`,
    };
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4}>
              <InfoRow label="fullName" value={user?.name} />
              <InfoRow label="Email" value={user?.email} />
              <InfoRow label="mobile" value={user?.mobile} />
              <MDBox>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize" mr={1}>
                  DOB:
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  {user?.DOB ? formatDate(user?.DOB) : "NA"}
                </MDTypography>
              </MDBox>
              <InfoRow textTransform="capitalize" label="gender" value={user?.gender} />
              <InfoRow label="country" value={user?.country} />
              <InfoRow
                label="Joined On"
                value={user?.createdAt ? formatDate(user?.createdAt) : "NA"}
              />
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
            <Grid item xs={12} md={6} xl={4}>
              <PlatformSettings />
            </Grid>
            {user?.personalHobbies?.length > 0 && (
              <Grid item xs={12} xl={4}>
                <ProfilesList title="Hobbies" profiles={user?.personalHobbies} shadow={false} />
              </Grid>
            )}
          </Grid>
        </MDBox>
        <MDBox pt={2} px={2} lineHeight={1.25}>
          <MDTypography variant="h6" fontWeight="medium">
            Profile Images
          </MDTypography>
        </MDBox>
        <MDBox p={2} display="flex" flexDirection="column">
          {user?.userProfiles?.length > 0 ? (
            <ImageGrid userProfiles={user.userProfiles} />
          ) : (
            <MDBox display="flex" alignItems="center" justifyContent="center" height={200}>
              <MDTypography variant="h6" color="textSecondary">
                No profile images available
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      </Header>
     </DashboardLayout>
  );
}

export default UserProfile;
